import { TextInput } from '@mantine/core';
import { useEffect, useState } from 'react';
import { BsSearch, BsX } from 'react-icons/bs';
import { useDebouncedCallback } from 'use-debounce';
import { DEBOUNCE_TIME } from 'utils/query';

interface Props {
  onChange: (value: string) => void;
  value?: string;
  placeholder?: string;
  searchOption?: boolean;
  testId?: string;
}

export const DebouncedInput = ({ onChange, value = '', placeholder, searchOption = false, testId = '' }: Props) => {
  const [inputValue, setInputValue] = useState<string>(value);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const debouncedChange = useDebouncedCallback((newValue: string) => {
    onChange(newValue);
  }, DEBOUNCE_TIME);

  const handleChange = (newValue: string) => {
    setInputValue(newValue);
    debouncedChange(newValue);
  };

  return (
    <TextInput
      leftSection={searchOption && <BsSearch />}
      placeholder={placeholder}
      onChange={(event) => handleChange(event.currentTarget.value)}
      value={inputValue}
      data-testid={`input-${testId}`}
      rightSection={
        searchOption && inputValue !== '' ? (
          <BsX
            size={30}
            style={{
              display: 'block',
              opacity: 2,
              cursor: 'pointer',
            }}
            onClick={() => handleChange('')}
          />
        ) : null
      }
    />
  );
};
